import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// components
import BackButton from 'components/backButton/backButton';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import DeceasedDetailsViewerComponent from '../components/deceasedViewer';
import PageTitle from 'components/title/title';

// services

// styles

// models
import { Card, Divider } from 'antd';
import HeirsViewerComponent from '../components/heirsViewer';
import { HeirTransfer } from '../models/heir';
import { onGetHeirsTransferById } from '../services/heirsService';
import NotificationService from 'core/services/notification';
import FilePreview from 'components/filePreview/filePreview';
import { formatFileSize } from 'utils/FileSize';

interface HeirsTransactionsViewPageProps {}

const HeirsTransactionsViewPage: FunctionComponent<HeirsTransactionsViewPageProps> = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [heirTransfer, setHeirTransfer] = useState<HeirTransfer>();

	useEffect(() => {
		getDeceasedData();
	}, []);

	const getDeceasedData = async () => {
		try {
			setIsLoading(true);
			const response = await onGetHeirsTransferById(id as string);
			setHeirTransfer(response);

			setIsLoading(false);
		} catch (error) {
			navigate('/dashboard/actions/heirs-transfer');
			NotificationService.error(t('COMMON.ERROR'), t('ACTIONS.HEIR_TRANSFER_NOT_EXIST'));
		}
	};

	return (
		<>
			<PageTitle name={t('TITLE.ACTIONS')} />

			<BackButton />

			<Card className="mt-3">
				<h5 className="mb-3">{t('ACTIONS.DECEASED_EQUITY_INF')}</h5>

				{isLoading ? (
					<LoadingComponent />
				) : (
					<>
						<DeceasedDetailsViewerComponent deceasedDetails={heirTransfer?.deceased!} />

						<Divider className="mt-0" />

						<HeirsViewerComponent heirs={heirTransfer?.heirs!} />

						<Divider />

						<div className="mb-3">
							<FilePreview
								name={t('ACTIONS.DETERMINE_HEIRS')}
								data={formatFileSize(heirTransfer?.heirs_limitation.size_in_kilobyte || 0)}
								downloadLink={heirTransfer?.heirs_limitation?.download_link}
							/>
						</div>

						<FilePreview
							name={t('ACTIONS.ESTATE_DISTRIBUTION')}
							data={formatFileSize(heirTransfer?.distribution_estate.size_in_kilobyte || 0)}
							downloadLink={heirTransfer?.distribution_estate?.download_link}
						/>
					</>
				)}
			</Card>
		</>
	);
};

export default HeirsTransactionsViewPage;
